import { User } from "@/entities/user/user"
import { defaultAvatar } from "@/utils/svgIcons"
import { Link } from "react-router-dom"

export function UserSmallProfile({
   user,
   size = "base",
   clickToGoToResume = false,
}: {
   user: User
   size?: "base" | "lg"
   clickToGoToResume?: boolean
}) {
   return (
      <div className="flex items-center gap-3">
         <div className="avatar">
            <div
               className={`rounded-full 
                 ${size === "base" && "w-12 md:w-18 "}
                 ${size === "lg" && "w-16 md:w-24 "}
                 `}
            >
               {clickToGoToResume ? (
                  <Link to={`/admin/resume-du-jeune/${user.id}`}>
                     {user.photo && <img src={user.photo} loading="lazy" />}
                     {!user.photo && <div className="">{defaultAvatar}</div>}
                  </Link>
               ) : (
                     <>
                        {user.photo && <img src={user.photo} loading="lazy" />}
                        {!user.photo && <div className="">{defaultAvatar}</div>}
                     </>
               )}
            </div>
         </div>
         <div className="flex flex-col gap-0 items-start">
            <div className="text-base font-bold">
               {clickToGoToResume ? (
                  <Link to={`/admin/resume-du-jeune/${user.id}`}>
                     {user.firstName} {user.lastName}
                  </Link>
               ) : (
                  <>
                     {user.firstName} {user.lastName}
                  </>
               )}
            </div>
            <div>
               {user.role === "young" && (
                  <p className="text-sm font-normal text-gray-500">
                     {/* <Link to={`/groupes/${user.group}`}> */}
                     {user.group}
                     {/* </Link> */}
                  </p>
               )}
            </div>
         </div>
      </div>
   )
}
